import { render, staticRenderFns } from "./UserProfilePage.vue?vue&type=template&id=20e1ca58&scoped=true"
import script from "./UserProfilePage.vue?vue&type=script&lang=js"
export * from "./UserProfilePage.vue?vue&type=script&lang=js"
import style0 from "./UserProfilePage.vue?vue&type=style&index=0&id=20e1ca58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1ca58",
  null
  
)

export default component.exports